import { useQuery } from '@tanstack/vue-query'
import { type MaybeRefOrGetter, toValue } from 'vue'
import {
  getProjectByAssetCode,
  updatePoNumber,
  getProjectDetailsByAssetCode, getProjectDetailsByProjectCode
} from '@/api/assets/projects'
import { createLogger } from "@/helpers/logging";
import { useMutationWithInvalidation } from '@/shared/composables/useMutationWithInvalidation'

export function useGetProjectByAssetCode(assetCode:MaybeRefOrGetter<string | undefined>){
    return useQuery({
        queryKey: ['assets:project',assetCode],
        meta: {
          logger: createLogger(`composables/projects/useGetProjectByAssetCode`)
        },
        queryFn: () => getProjectByAssetCode(toValue(assetCode)!),
        enabled() {
            const value = toValue(assetCode)

            return value !== undefined
        }
    })
}

export function useProjectDetails(by: MaybeRefOrGetter<'asset' | 'project'>, value: MaybeRefOrGetter<number|null|undefined>) {
  return useQuery({
    queryKey: ['projects:details', by, value],
    meta: {
      logger: createLogger('composables/projects/useProjectDetails')
    },
    enabled() {
      const reducedValue = toValue(value)

      return reducedValue !== null && reducedValue !== undefined && reducedValue > 0
    },
    queryFn: () => {
      const reducedBy = toValue(by)
      const reducedValue = toValue(value)!

      if (reducedBy === 'asset') {
        return getProjectDetailsByAssetCode(reducedValue.toString())
      } else {
        return getProjectDetailsByProjectCode(reducedValue)
      }
    }
  })
}

type ProjectPoNumber = {
    projectCode: MaybeRefOrGetter<number>,
    poNumber: MaybeRefOrGetter<string|null>
}

export const useUpdatePoNumber = (assetCode: MaybeRefOrGetter<string>) => useMutationWithInvalidation(
  (projectPoNumber : ProjectPoNumber) => updatePoNumber({
    projectCode: toValue(projectPoNumber.projectCode),
    poNumber: toValue(projectPoNumber.poNumber)
  }),
  [
    ['assets:project', assetCode],
  ]
)
